import { where } from "firebase/firestore";
import { Collection, WhereField } from '../../shared/constants';
import { addDoc, getAllDocsByCollection, getDocById, getDocByQueries, updateDoc } from './collectionBaseWorker';

export const addRevenda = async ({ data }) => {
    const doc = await addDoc({ collection: Collection.RESALE, data: data })
    return doc.id;
}

export const getRevendaById = async ({ id }) => {
    if (id) {
        return await getDocById({ collection: Collection.RESALE, id: id })
    }
    return null
}

export const updateRevenda = async ({ id, data }) => {
    await updateDoc({ collection: Collection.RESALE, id: id, data: data })
}

export const updateRevendaById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.RESALE, id: id, data: data })
}

export const getRevendaByCode = async ({ code }) => {
    if (code) {
        return await getDocByQueries({
            collection: Collection.RESALE,
            queries: [
                where(WhereField.CODIGO, "==", code)
            ]
        })
    }
    return null
}

export const getAllRevendas = async () => {
    return await getAllDocsByCollection({ collection: Collection.RESALE })
}